const dateFormat = "MM/DD/YYYY"
const dateFormatForBackend = "YYYY/MM/DD"
const errorTimeout = 3000
const xlsxFileMimeType: string =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
const promotionUploaderSampleFile =
  "https://kiafiles.s3.us-west-2.amazonaws.com/PromotionsUploadFile11.29.23.xlsx"

export { dateFormat, errorTimeout, dateFormatForBackend, xlsxFileMimeType,promotionUploaderSampleFile }
